import { useInView } from 'react-intersection-observer';
import CollapsibleSection from './components/CollapsibleSection';
import IngredientsFooter from './components/IngredientsFooter';
import parse from 'html-react-parser';
import withFraction from "./utils/withFraction"; 
import './scss/Ingredients.scss';

function Ingredients({ ingredients }) {

  const { ref, inView, entry } = useInView();

  // get the total number of ingredients to display in Ingredients heading
  const ingredientsCount = ingredients.reduce((acc, curr) => 
    acc + curr.items.length, 0
  );

  const ingredientsList = ingredients.map(list =>
    <ul id={list.id} key={list.id}>
      {list.name && <p className="list-name">{list.name}</p>}
      {list.items.map(item => 
        <li key={item.name}>
          <input type="checkbox" id={item.name} className="dim-when-checked" />
          <label htmlFor={item.name}>
            <ingredient-name>{parse(item.name)}</ingredient-name> 
            { item.preparation && <ingredient-preparation>, {item.preparation}</ingredient-preparation> }
            { item.number && 
              <ingredient-amount>(
                <ingredient-number>
                  { item.unit === 'g' ? item.number : withFraction(item.number)}
                </ingredient-number>
                { item.unit && <ingredient-unit>{item.unit}</ingredient-unit> }
              )</ingredient-amount>
            }
            { item.note && <ingredient-note>{item.note}</ingredient-note> }
          </label>
        </li>
      )}
      {list.note && <p className="list-note">{list.note}</p>}
    </ul>
  )

  return (
    <CollapsibleSection  
      id="ingredients"
      name={`Ingredients (${ingredientsCount})`}
      defaultCollapsed={false}
      card={true}
    >
      <div className="ingredients-container section-content" ref={ref}>
        {ingredientsList}
      </div>
      { !inView && entry?.boundingClientRect.top < 0 ? 
        <IngredientsFooter ingredientsList={ingredientsList} />
        : null 
      }
    </CollapsibleSection>
  );
}

export default Ingredients;